import {HedgePresetsModule} from '../hedge-presets/hedge-presets.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DevExtremeModule } from '../devextreme.module';
import { OptionsCommonModule } from '../options-common/options-common.module';
import { GenericConfirmationDialogModule } from '../generic-confirmation-dialog/generic-confirmation-dialog.module';
import { OpgCopilotTabBarComponent } from './opg-copilot-tab-bar.component';
import { OpgCopilotDateBlockComponent } from './opg-copilot-date-block.component';
import { OpgSideQuestionnaireComponent } from './opg-side-questionnaire.component';
import { OpgOverrideIndicatorsComponent } from './opg-override-indicators.component';
import { OpgCopilotBreadcrumbBarComponent } from './opg-copilot-breadcrumb-bar.component';
import { OpgCopilotComponent } from './opg-copilot.component';
import { OpgCopilotResultsListComponent } from './opg-copilot-results-list.component';
import { OpgTradeCardComponent } from './opg-trade-card.component';
import { OpgTradeStackComponent } from './opg-trade-stack.component';
import { OPG_TRADES_SKILL } from './opg-trades-skill';
import { BackendOpgTradesSkill } from './backend-opg-trades-skill';

// THE SELECT COPILOT (CR-20260804-001, the two-copilots reversal - ruling AF). This module is
// the whole OPG Co-Pilot, extracted here so BOTH hosts render the LITERAL same thing: the OPG
// panel and the HedgeMatrix Co-Pilot's Select tab ("the same thing used from the different
// pop-ups" - the owner). The v1 extraction carried the five questionnaire components; the
// reversal completes it with the orchestrator, the results side and the skill client - one
// component, one operation, one engine, two hosts. A host supplies ONLY an IOpgCopilotFacade
// implementation (opg-copilot-facade.ts) - the copilot's entire coupling surface.
//
// The components keep their Opg names and selectors for now: they were born in OPG and the
// wire names stay regardless (ESS re-encode hazard); the product name is Select Copilot.
@NgModule({
    imports: [HedgePresetsModule,
        CommonModule,
        DevExtremeModule,
        OptionsCommonModule,
        GenericConfirmationDialogModule
    ],
    exports: [
        OpgCopilotTabBarComponent,
        OpgCopilotDateBlockComponent,
        OpgSideQuestionnaireComponent,
        OpgOverrideIndicatorsComponent,
        OpgCopilotBreadcrumbBarComponent,
        OpgCopilotComponent,
        OpgCopilotResultsListComponent,
        OpgTradeCardComponent,
        OpgTradeStackComponent
    ],
    declarations: [
        OpgCopilotTabBarComponent,
        OpgCopilotDateBlockComponent,
        OpgSideQuestionnaireComponent,
        OpgOverrideIndicatorsComponent,
        OpgCopilotBreadcrumbBarComponent,
        OpgCopilotComponent,
        OpgCopilotResultsListComponent,
        OpgTradeCardComponent,
        OpgTradeStackComponent
    ],
    providers: [
        // The REAL backend skill client behind the DI token (CR-20260716-001, ADR-037).
        // MODULE-LEVEL: ONE instance serves EVERY hosting panel - OPG panels and HedgeMatrix
        // Select tabs alike (its pending-run map, not a single-flight slot, carries concurrent
        // panels' runs; the backend registry scopes supersede per panelInstanceId). Bound
        // UNCONDITIONALLY; the f02b3b2a secure-element grant is what lights the feature.
        // MockOpgTradesSkill STAYS in the tree as the karma spec fixture.
        { provide: OPG_TRADES_SKILL, useClass: BackendOpgTradesSkill }
    ]
})
export class CopilotSharedModule { }
